// Minimally this needs to support the list Azure supports - https://github.com/Azure/portaldocs/blob/master/portal-sdk/generated/portalfx-localization.md#understanding-localization-list-of-accepted-languages
// These need to be lower cased to support lookup below.
const supportedLanguages = ["en", "de", "es", "fr", "it", "id","ja", "ko", "ru", "cs", "nl", "hu", "pl", "sv", "tr", "pt-br", "pt-pt", "zh-hans", "zh-hant"];

export class CultureUtility {
    private static _rawLocale: string;
    private static _displayLanguage: string;
    private static _cultureCode: string;

    /**
     * The raw locale typically supplied by Azure on the query string ("l" parameter).
     */
    public static get rawLocale(): string | undefined {
        return this._rawLocale;
    }

    /**
     * One of the supported display languages or undefined. This will be set when setLocale is called.
     */
    public static get displayLanguage(): string | undefined {
        return this._displayLanguage;
    }

    public static get cultureCode(): string | undefined {
        return this._cultureCode;
    }

    public static setLocale(rawLocale: string) {
        this._rawLocale = rawLocale;
        this._displayLanguage = this.toSupportedDisplayLanguage(this._rawLocale);
        this._cultureCode = this.toCultureCode(this._rawLocale);
    }

    /**
     * Convert lang code to a supported language - or roughly language... one of the language codes supported by Azure.
     * @param langCode - Valid Locale (<display language>[.<Format Culture>])
     * @returns - Display language if we can determine it from langCode otherwise undefined.
     */
    private static toSupportedDisplayLanguage(langCode: string): string | undefined {
        if (!langCode) {
            return undefined;
        }

        let displayLanguage: string;
        let parts = langCode.toLowerCase().split(".");
        if (parts.length > 2) {
            return undefined;
        }
        displayLanguage = parts[0];

        // Check for direct match before starting to guess.
        if (supportedLanguages.indexOf(displayLanguage) !== -1) {
            return displayLanguage;
        }

        // Perhaps it is one of our two letter languages with a -(other) - ie en-US, en-CA, etc... 
        parts = displayLanguage.split("-");
        if (parts.length === 2 && parts[0].length == 2 && supportedLanguages.indexOf(parts[0]) !== -1) {
            return parts[0];
        }

        return undefined;
    }

     /**
     * Converts the raw locale to a CultureCode (e.g. it-it, en-us, ja-jp)
     * @param rawLocale - Valid Azure effective Locale (<display language>[.<Format Culture>])
     * @returns - CultureCode if it's available in the rawLocale otherwise undefined.
     */
    private static toCultureCode(rawLocale: string): string | undefined {
        if (!rawLocale) {
            return undefined;
        }

        let cultureCode: string;
        let parts = rawLocale.toLowerCase().split(".");

        // culturecode can be found in the rawLocale in these cases
        // lang.culturecode
        // culturecode
        if (parts.length == 1 || parts.length == 2) {
            cultureCode = parts[parts.length - 1];

            if (cultureCode.indexOf("-") !== -1) {
                return cultureCode;
            }
        }

        return undefined;
    }

}



// WEBPACK FOOTER //
// ./Client/Resources/CultureUtility.ts